import {Grid, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {getLocationSuppliersInRadius} from '../requests/location-requests';
import PropTypes from 'prop-types';
import moment from 'moment';
import {DateFormats} from '../../constants/securspace-constants';
import LocationProfileCardList from './locationProfileList/LocationProfileCardList';
import {useFeatureFlags} from "../../../hooks/routing/useFeatureFlags";
import {styled} from "@mui/material/styles";

const SimilarYardsHeaderContainer = styled(Grid)(() => ({
  marginTop: '1.57rem'
}));

const SimilarYardsHeaderText = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: '1.43em',
  lineHeight: '160%',
  letterSpacing: '0.01em',
}));

const SimilarYardsListContainer = styled(Grid)(() => ({
  marginTop: '2.07rem',
  marginBottom: '3.86rem',
}));

const MILE_RADIUS = 15;
const MAX_PROFILES = 4;

const LocationProfileSimilarYardsNearby = ({ location, mileRadius, maxProfiles }) => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(false);

  const { optimizedLocationSearch } = useFeatureFlags();

  useEffect(() => {
    if (!location) return;
    const { locationId, addressLatitude, addressLongitude } = location;
    const today = moment(new Date());
    setLoading(true)
    getLocationSuppliersInRadius(
      optimizedLocationSearch,
      addressLatitude,
      addressLongitude,
      mileRadius ? mileRadius : MILE_RADIUS,
      today.format(DateFormats.DAY),
      today.add(1, 'days').format(DateFormats.DAY),
      1
    ).then(response => {
      if (response.body) {
        setLoading(false)
        setListings(response.body.sort((a, b) =>  {
          return (Number.parseFloat(a.distance) || 0) - (Number.parseFloat(b.distance) || 0);
        }).filter(location => location.locationId !== locationId).slice(0, maxProfiles ? maxProfiles : MAX_PROFILES));
      }
    }).catch(() => {
      // do nothing
      setLoading(false)
    });
  }, [optimizedLocationSearch, location, mileRadius, maxProfiles]);

  return (
    listings.length > 0 && <section className='w-100'>
      <Grid container item direction='column'>
        <SimilarYardsHeaderContainer item xs>
          <SimilarYardsHeaderText component='h3' color='textPrimary'>Similar yards nearby</SimilarYardsHeaderText>
        </SimilarYardsHeaderContainer>
        <SimilarYardsListContainer container item xs wrap='nowrap'>
          <LocationProfileCardList loading={loading} locations={listings} />
        </SimilarYardsListContainer>
      </Grid>
    </section>
  );
};

LocationProfileSimilarYardsNearby.propTypes = {
  location: PropTypes.object,
  mileRadius: PropTypes.number,
  maxProfiles: PropTypes.number,
};

export default LocationProfileSimilarYardsNearby;
